import request from '@/utils/request';
import Vue from 'vue';
//获取功能列表
export function getmenusList () {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/routes/getRoutes`
    // headers: {
    //   Authorization: localStorage.getItem('token') || ''
    // }
  });
}
// //登录
// export function loginByPassword (params) {
//   return request({
//     method: 'post',
//     url: `/dragon/getLoginCode/{phone}`,
//     data: params
//   });
// }
// export function logout () {
//   return request({
//     method: 'post',
//     url: `${Vue.prototype.$conf.visaService}/logout`
//   });
// }
// //更新角色
// export function updateTokenByRole (params) {
//   return request({
//     method: 'post',
//     url: `${Vue.prototype.$conf.visaService}/updateTokenByRole`,
//     data: params
//     // headers: {
//     //   Authorization: localStorage.getItem('token') || ''
//     // }
//   });
// }
// 查询当前账号所有角色
// export function getAllAuthList () {
//   return request({
//     method: 'get',
//     url: `${Vue.prototype.$conf.visaService}/role/queryRolesByUser`
//   });
// }

// //修改密码
// export function modifyPassword (params) {
//   return request({
//     method: 'post',
//     url: `${Vue.prototype.$conf.visaService}/user/modifyPassword`,
//     data: params
//   });
// }

//获取验证码
export function getLoginCode (params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/dragon/getLoginCode/${params}`,
  });
}
//验证码登录  /dragon/login
export function dragonLogin (params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/dragon/login`,
    data:params
  });
}

